/**
 * Thin wrappers around the /api/invoices endpoints. Every call is made via
 * the authenticated axios client from useApiClient(); pass the instance in
 * rather than re-creating one per call.
 */
export async function listInvoices(api) {
  const r = await api.get("/invoices");
  return r.data?.invoices || [];
}

export async function getInvoice(api, invoiceId) {
  const r = await api.get(`/invoices/${invoiceId}`);
  return r.data;
}

export async function setInvoicePaid(api, invoiceId, paid) {
  const r = await api.patch(`/invoices/${invoiceId}`, { paid });
  return r.data;
}

export async function deleteInvoice(api, invoiceId) {
  const r = await api.delete(`/invoices/${invoiceId}`);
  return r.data;
}

export async function listTrashed(api) {
  const r = await api.get("/invoices/trash");
  return r.data?.invoices || [];
}

export async function restoreInvoice(api, invoiceId) {
  const r = await api.post(`/invoices/${invoiceId}/restore`);
  return r.data;
}
